<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input-number style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                
                <a-col :span="12">
                    <a-form-item label="联系人" name="contacts">
                        <a-input style="width:100%" v-model:value="form.contacts" placeholder="请输入联系人" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="contactNumber">
                        <a-input style="width:100%" v-model:value="form.contactNumber" placeholder="请输入联系电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="需求反馈内容" name="replyContent">
                        <a-textarea v-model:value="form.replyContent" placeholder="请输入需求反馈内容"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeDemandReply} from "@/api/finance";
import {innovation} from "@/config/variableConfig";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                companyCode: null,
                replyContent: null,
                contacts: null,
                contactNumber: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    replyContent: [dataCheck.required({})],
                    contacts: [dataCheck.required({})],
                    contactNumber: [dataCheck.required({}),dataCheck.phone]
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeDemandReply.edit
                } else {
                    return financeDemandReply.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
